import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import { Loader } from 'semantic-ui-react'

import ErrorMassive from 'Components/ErrorMassive'

import * as actions from './actions'
import * as asyncActions from './actionsAsync'
import * as selectors from './selectors'

const MyOrdersModuleHOC = WrappedComponent => {
  class MyOrdersModuleHOC extends Component {
    static propTypes = {
      deleteSearch: PropTypes.func.isRequired,
      form: PropTypes.object.isRequired,
      getUserSearches: PropTypes.func.isRequired,
      searches: PropTypes.object.isRequired,
      setNameFilter: PropTypes.func.isRequired,
      setNameForm: PropTypes.func.isRequired,
      setPage: PropTypes.func.isRequired,
      setSortBy: PropTypes.func.isRequired,
      slicedSortedSearches: PropTypes.array.isRequired,
      toggleLayout: PropTypes.func.isRequired,
      toggleLimit: PropTypes.func.isRequired,
      toggleSortOrder: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    componentDidMount() {
      const { getUserSearches, searches, user } = this.props

      if (!searches.done && !searches.pending) {
        getUserSearches(user.id)
      }
    }

    render() {
      const { searches, slicedSortedSearches } = this.props

      return (
        <div>
          <ErrorMassive enabled={searches.error} message="Something went wrong." />

          {searches.pending && !searches.error && <Loader content="Searching for your searches..." size="massive" active />}

          {slicedSortedSearches && !searches.error && !searches.pending && (
            <WrappedComponent {...this.props} searches={slicedSortedSearches} />
          )}
        </div>
      )
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    form: selectors.form(state),
    layout: selectors.layout(state),
    limit: selectors.limit(state),
    pagination: selectors.calculatePagination(state),
    searches: selectors.searches(state),
    slicedSortedSearches: selectors.slicedSortedSearches(state),
    sortBy: selectors.sortBy(state),
    sortOrder: selectors.sortOrder(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    deleteSearch: (searchId, user) => dispatch(asyncActions.deleteSearch(searchId, user)),
    getUserSearches: userId => dispatch(asyncActions.getUserSearches(userId)),
    setNameFilter: name => dispatch(actions.setNameFilter(name)),
    setNameForm: name => dispatch(actions.setNameForm(name)),
    setPage: page => dispatch(actions.setPage(page)),
    setSortBy: column => dispatch(actions.setSortBy(column)),
    toggleLayout: () => dispatch(actions.toggleLayout()),
    toggleLimit: () => dispatch(actions.toggleLimit()),
    toggleSortOrder: order => dispatch(actions.toggleSortOrder()),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(MyOrdersModuleHOC)
}

export default MyOrdersModuleHOC
